const TOOLTIP_OPEN = "tooltip.open";

export { TOOLTIP_OPEN as T };
//# sourceMappingURL=utils.js.map
